import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

export interface SeriesScopeDialogData {
  title: string;
  message: string;
  singleLabel?: string;
  allLabel?: string;
}

export type SeriesScopeResult = 'single' | 'all' | null;

@Component({
  selector: 'app-series-scope-dialog',
  template: `
    <app-entity-mat-dialog-title [title]="data.title"></app-entity-mat-dialog-title>
    <div mat-dialog-content>
      <p *ngIf="!saving">{{ data.message }}</p>
      <div *ngIf="saving" class="saving-indicator">
        <mat-spinner diameter="24"></mat-spinner>
        <span>Updating...</span>
      </div>
    </div>
    <mat-dialog-actions align="end" *ngIf="!saving">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="onSelect('single')">{{ data.singleLabel }}</button>
      <button mat-raised-button (click)="onSelect('all')">{{ data.allLabel }}</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .saving-indicator {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 8px 0;
    }
  `],
})
export class SeriesScopeDialogComponent {
  saving = false;
  scopeSelected$ = new Subject<SeriesScopeResult>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SeriesScopeDialogData,
    public dialogRef: MatDialogRef<SeriesScopeDialogComponent>
  ) {
    this.data.singleLabel = this.data.singleLabel || 'This Event Only';
    this.data.allLabel = this.data.allLabel || 'All Future Events';
  }

  onSelect(scope: SeriesScopeResult): void {
    this.saving = true;
    this.dialogRef.disableClose = true;
    this.scopeSelected$.next(scope);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
